import type { CalendarEvent } from 'paintscout'
import { removeAuth0Prefix } from '@paintscout/util'

export interface ScheduledEventFilterValues {
  selectedProjectTypes: string[]
  selectedSalesReps: string[]
  selectedProjectManagers: string[]
  minPrice: string
  maxPrice: string
}

export interface ProductionCrewFilterItem {
  _id: string
  projectManager?: {
    id?: string
  }
}

export function filterScheduledEvents(args: {
  events: CalendarEvent[]
  crews: ProductionCrewFilterItem[]
  filters: ScheduledEventFilterValues
}): CalendarEvent[] {
  const { events, crews, filters } = args
  const { selectedProjectTypes, selectedSalesReps, selectedProjectManagers, minPrice, maxPrice } = filters

  const minPriceValue = minPrice ? parseFloat(minPrice) : null
  const maxPriceValue = maxPrice ? parseFloat(maxPrice) : null

  return events.filter((event) => {
    if (selectedProjectTypes.length > 0 && !selectedProjectTypes.includes(event.projectType)) {
      return false
    }

    if (selectedSalesReps.length > 0) {
      const estimatorId = event.estimator?.id
      if (
        !estimatorId ||
        !selectedSalesReps.some(
          (selectedSalesRepId) => removeAuth0Prefix(selectedSalesRepId) === removeAuth0Prefix(estimatorId)
        )
      ) {
        return false
      }
    }

    if (minPriceValue !== null || maxPriceValue !== null) {
      const rawValue = event.deal?.value
      const eventValue = typeof rawValue === 'number' ? rawValue : 0

      if (minPriceValue !== null && eventValue < minPriceValue) {
        return false
      }

      if (maxPriceValue !== null && eventValue > maxPriceValue) {
        return false
      }
    }

    if (selectedProjectManagers.length === 0) {
      return true
    }

    const crew = crews.find((currentCrew) => currentCrew._id === event.crew)
    const projectManagerId = crew?.projectManager?.id

    if (!projectManagerId) {
      return false
    }

    return selectedProjectManagers.some(
      (selectedProjectManagerId) => removeAuth0Prefix(selectedProjectManagerId) === removeAuth0Prefix(projectManagerId)
    )
  })
}
